import AppSettings from '../AppSettings';
// Librairies
import Axios from 'axios';
import Cookies from 'universal-cookie';
// Services
import { showToast } from '../utils/ToastsUtil';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

// Activation de l'accès des assistants IA (serveur MCP) par une organisation, en plus du droit de sa licence
export default class McpOrganizationsService {
    // { isLicensed, isEnabled, enabledDate, enabledBy, isOwner }, null si le serveur MCP est désactivé (404) ou en cas d'erreur
    static getStatus(organizationId) {
        return Axios.get(BACKEND_ENDPOINT + 'mcpOrganizations/' + organizationId, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => response.data, () => null);
    }

    // isAcknowledged : le propriétaire a accepté l'avertissement sur le passage des données par le fournisseur de l'assistant
    static setEnabled(organizationId, isEnabled, isAcknowledged) {
        return Axios.put(BACKEND_ENDPOINT + 'mcpOrganizations/' + organizationId, { isEnabled, isAcknowledged }, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            showToast(isEnabled ? 'mcp_organization_enabled' : 'mcp_organization_disabled');
            return response.data;
        }, () => {
            showToast('mcp_organization_update_failed');
            return null;
        });
    }
}
